module.exports = __webpack_public_path__ + "img/add-plus.da9ab606.svg";